import React, { useState, useContext, useEffect, useRef } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import FaturadoLinkDePagamento from '../FaturadoLinkDePagamento/FaturadoLinkDePagamento';
import PaginaLinkPagamentoInvalido from '../../Pages/PaginaLinkPagamentoInvalido/PaginaLinkPagamentoInvalido';
import PaginaLinkPagamentoPago from './../PaginaLinkDePagamentoPago/PaginaLinkDePagamentoPago';
import PaginaCardNotasFaturadas from '../../CardNotasFaturadas/CardNotasFaturadas';
import PaginaCardNotasAVista from '../../CardNotasAVista/CardNotasAVista';
import ComprasFaturadas from './../../ComprasFaturadas/ComprasFaturadas';
import { Typography } from '@mui/material';
import Rodape from '../../Rodape/Rodape';
import { useLocation, useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { identificacaoUsuarioLogado } from './../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import { MyContext } from '../../../context/MyContext';
import { Box } from '@mui/material';
import api from './../../../services/api';
import { Grid, Card } from '@mui/material';


//function Compartilhado() {
const Compartilhado = () => {
    let history = useHistory();
    const location = useLocation();
    const toastMensagemError = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });
    const toastMensagemErrorLogin = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });
    const { destinoPagina, setDestinoPagina } = useContext(MyContext);
    const [showingToast, setShowingToast] = useState(0);
    const [showingToastNeedLogin, setShowingToastNeedLogin] = useState(1);
    const [dadosConteudoParaImpressao, setDadosConteudoParaImpressao] = useState(null);
    const [satonImpressaoProcessoId, setSatonImpressaoProcessoId] = useState(null);
    const [satonImpressaoProcessoIdLoja, setSatonImpressaoProcessoIdLoja] = useState(null);
    const { showModalMeuPagamentoFaturado, setShowModalMeuPagamentoFaturado } = useContext(MyContext);
    const {linkPreVenda, setLinkPreVenda} = useContext(MyContext); // = useState(null);
    const [linkPagamento, setLinkPagamento] = useState(null);    
    const {linkPagamentoMensagem, setLinkPagamentoMensagem} = useContext(MyContext); // = useState(null);
    const {linkPagamentoRetornado, setLinkPagamentoRetornado} = useContext(MyContext); // = useState(false);
    const {linkPago, setLinkPago} = useContext(MyContext); // = useState(false);
    const [pagamentoJaEfetuado, setPagamentoJaEfetuado] = useState(false);
    const [valorRestante, setValorRestante] = useState(0.00);
    const [expiraEm, setExpiraEm] = useState(null);
    const queryParams = new URLSearchParams(location.search);
    let totalPago = 0.00;

    useEffect(() => {
        const dados = queryParams.get('pagamento');

        console.log("MVVVVVU ", dados);

        const aguardar = async (dados) => {

            console.log("MVA", dados);

            await descriptografarLinkPagamento(dados);
        };
        aguardar(dados);        
    }, []);


    useEffect(() => {
        if (linkPreVenda != null) {
            totalPago = linkPreVenda[0]?.especie?.reduce((sum, pagamento) => sum + (pagamento.finalizado == 1 ? pagamento.valor : 0), 0) || 0;
            if (totalPago >= linkPreVenda[0]?.preVendas?.total_geral){
               setLinkPagamentoMensagem({ cabecalho: "Link de Pagamento Já Concluído", corpo: "Pagamento já foi finalizado, agora é só aguardar o recebimento." });
               setLinkPagamentoRetornado(true);            
               setValorRestante(0.00);
            }
            else
            {
                setValorRestante(linkPreVenda?.preVendas?.total_geral - totalPago);                
            }
        }
    }, [linkPreVenda]);

    const descriptografarLinkPagamento = async (dados) => {
        if (dados != null) {
            const objeto = { encryptedText: dados };
            
            console.log("LINKE ", objeto);

            const ret = await api.post(`Saton/UsarLinkPagamentoFaturado`, objeto).then((response) => {
                console.log("LINKA ", objeto);
                console.log("LINKAX ", response.data);
                setLinkPagamento(response.data);
                setLinkPagamentoRetornado(!linkPagamentoRetornado);
                return (response.data);

            }).catch((e) => {
                console.log("LINKB ", e);

                setLinkPagamentoMensagem({ cabecalho: "Link de Pagamento Inválido", corpo: "Por Favor, Solicite ao Emissor um Novo Link de Pagamento." });
                setLinkPagamento(null);
                setLinkPagamentoRetornado(true);
                // SetLinkPagamento(null);
                // toastMensagemError("Falhou Geral: " + e.message)
            });

            if (ret.error != undefined) {
                
                console.log("LINKC ", ret);
                console.log("MVE");

                setLinkPagamentoMensagem({ cabecalho: ret.error, corpo: "Por Favor, Solicite ao Emissor um Novo Link de Pagamento." });
                setLinkPagamento(ret);
                abrirPaginaParaConcluirPagamentos(ret);
                setLinkPagamentoRetornado(true);
            }
            else {
                console.log("MVF");
                console.log("LINKD ", ret);

                setLinkPagamentoMensagem(null);
                setLinkPagamento(ret);
                abrirPaginaParaConcluirPagamentos(ret);
                setLinkPagamentoRetornado(true);
            }
        }
    }

    // useEffect(() => {
    //     console.log("MVF", linkPagamento, linkPagamentoRetornado);
    //     if (linkPagamentoRetornado) {            
    //         console.log("MVA", linkPagamento);
    //         if (linkPagamento.error != undefined){
    //             console.log("MVD", linkPagamento);
    //             SetLinkPagamentoMensagem({ cabecalho: linkPagamento.error, corpo: "XPor Favor, Solicite ao Emissor um Novo Link de Pagamento." });
    //         }
    //         else{
    //             console.log("MVE", linkPagamento);
    //             SetLinkPagamentoMensagem({ cabecalho: "Link de Pagamento Inválido", corpo: "YPor Favor, Solicite ao Emissor um Novo Link de Pagamento." });
    //         }
    //         SetLinkPagamentoRetornado(true);
    //     } 
    //     else
    //     {
    //         console.log("MVG", linkPagamento);
    //     }       
    // }, [linkPagamentoRetornado]);


    const abrirPaginaParaConcluirPagamentos = async (linkPagamento) => {
        if (typeof (linkPagamento) !== 'object') { // Contém Erros e Não Deverá Continuar o Processamento
            return null;
        }
        if (linkPagamento.hasOwnProperty("error")) {
            return null;
        }

        let _userId = 0; // idCliente
        let _userIdloja = 0; // idClienteLoja

        let _preVendaId = 0; // idPreVenda
        let _preVendaIdloja = 0; // idPreVendaLoja

        let _processoId = 0; // idProcesso
        let _processoIdLoja = 0; // idProcessoLoja
        let _expiraEm = null; // expiraEm
        let _valorRestante = 0.00 // valor da Venda Considerando que o Link é o Valor Total da Venda
        let _nomeFullRazaoSocialLogado = null; // Razão Social

        if (linkPagamento.hasOwnProperty("aVista")) {
            linkPagamento = linkPagamento?.aVista.split('/');

            _userId = linkPagamento[0].split("=")[1]; // idCliente
            _userIdloja = linkPagamento[1].split("=")[1]; // idClienteLoja

            _preVendaId = linkPagamento[2].split("=")[1]; // idPreVenda
            _preVendaIdloja = linkPagamento[3].split("=")[1]; // idPreVendaLoja

            _processoId = linkPagamento[4].split("=")[1]; // idProcesso
            _processoIdLoja = linkPagamento[5].split("=")[1]; // idProcessoLoja
            
            _valorRestante = linkPagamento[6].split("=")[1]; // valor

            _nomeFullRazaoSocialLogado = linkPagamento[7].split("=")[1]; // Razão Social

            _expiraEm = linkPagamento[8].split("=")[1]; // expiraEm           

            // console.log("MIGUEL 1234 ", linkPagamento);
            // console.log("MIGUEL 12345 ", _valorRestante);

            let dados = null;
            try {
                console.log("MIGUEL 456 ", `Pedidos/AbrirPedido/${_userId}/${_userIdloja}/${_preVendaId}/${_preVendaIdloja}/${_valorRestante}/1`);
                await api.get(`Pedidos/AbrirPedido/${_userId}/${_userIdloja}/${_preVendaId}/${_preVendaIdloja}/${_valorRestante}/1`)
                    .then((response) => {
                        console.log("MIGUEL 467 ", response);
                        if(response?.data?.preVendas.pagamento == 1){
                            setLinkPagamentoMensagem({ cabecalho: "Link de Pagamento Já Recebido", corpo: "Pagamento já foi recebido, agora é só aguardar a entrega." });
                            //setLinkPagamentoRetornado(true);                         
                            setLinkPago(true);   
                        }
                        else{
                            setLinkPreVenda(response.data);
                            setLinkPago(false);
                        }                        
                        // setDadosConteudoParaImpressao(response.data);
                        // setShowModalMeuPagamentoFaturado(true);
                    })
                    .catch((erro) => {
                        //setDadosConteudoParaImpressao(null);
                        console.log("MIGUEL 459 ", erro.response);
                        if (erro.response != null && erro.response.status === 500)
                        {
                            return null;
                        }
                        else
                        {
                            toastMensagemError("Falhou: " + erro.message)
                        }                        
                    });
            } catch (e) {
                // setDadosConteudoParaImpressao(null);
                // toastMensagemError("Falha Geral: " + e.message)
                return null;
            };


            // let dados = null;
            // try {
            //     console.log("MIGUEL 456 ", `Pedidos/VerificarPagamento/${_userId}/${_userIdloja}/${_preVendaId}/${_preVendaIdloja}`);
            //     await api.get(`Pedidos/VerificarPagamento/${_userId}/${_userIdloja}/${_preVendaId}/${_preVendaIdloja}`)
            //         .then((response) => {
            //             console.log("MIGUEL 467 ", response);
            //             setLinkPreVenda(response.data);
            //             // setDadosConteudoParaImpressao(response.data);
            //             // setShowModalMeuPagamentoFaturado(true);
            //         })
            //         .catch((erro) => {
            //             //setDadosConteudoParaImpressao(null);
            //             console.log("MIGUEL 459 ", erro.response);
            //             if (erro.response != null && erro.response.status === 500)
            //             {
            //                 return null;
            //             }
            //             else
            //             {
            //                 toastMensagemError("Falhou: " + erro.message)
            //             }                        
            //         });
            // } catch (e) {
            //     // setDadosConteudoParaImpressao(null);
            //     // toastMensagemError("Falha Geral: " + e.message)
            //     return null;
            // };
        }
    };


    // console.log("MV 4444", linkPagamento, linkPagamentoMensagem, linkPagamentoRetornado, dadosConteudoParaImpressao);

    console.log("MIGUEL 5555",linkPagamento);    
    console.log("MIGUEL 6666",linkPreVenda);    
    console.log("MIGUEL 7777", valorRestante);  
    console.log("MIGUEL 8888", linkPago, linkPagamentoMensagem);  



    return (
        <div>
            {/* <Box sx={{ flexGrow: 1, width: "100vw" }}>
                <Box sx={{ marginTop: '5px', marginBottom: '5px', marginRight: '10px' }}>
                    <Link to="/"><img src={LogoName} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '180px', height: 'auto' }} /></Link>
                </Box>
            </Box> */}
            {/* <FaturadoLinkDePagamento /> */}
            <NavBarTop />
            
            {(linkPago ? <PaginaLinkPagamentoPago props={linkPagamentoMensagem} /> : <></> )}

            {(linkPago == false && linkPagamentoRetornado
                ?
                (linkPagamentoMensagem != null
                    ?
                    <PaginaLinkPagamentoInvalido props={linkPagamentoMensagem} />
                    :
                    (linkPagamento != null && dadosConteudoParaImpressao != null
                        ?
                        <PaginaCardNotasFaturadas props={dadosConteudoParaImpressao} />
                        :
                        (valorRestante > 0 
                         ? 
                            <PaginaCardNotasAVista props={linkPagamento} venda={linkPreVenda} />
                            // <PaginaCardNotasAVista props={linkPagamento} />
                         : 
                          <Box height={'500px'}                          
                            style={{
                            textAlign: 'center',
                            color: '#000000',
                            alignSelf: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlignVertical: 'center',
                            alignContent: 'center',
                          }}>
                            Aguarde...
                          </Box>
                        )                        
                    )
                )
                :
                <></>
            )}
            <ToastContainer />
            <Rodape />
        </div>
    );
}
export default Compartilhado